export default "__VITE_ASSET__8ulPYVyr__"